import { TimeInLieu } from "../../API";
import { gqlQuery, QueryType, toDbDates } from "../../lib";

type QueryProps = {
  id: string;
  dates: Interval | null;
};

export const timeInLieusQuery =
  ({ dates, id }: QueryProps) =>
  (input: Omit<QueryType, "req">) => {
    if (dates === null) {
      throw new Error(`Incorrect date range. Value is ${dates}`);
    }
    const dateRange = toDbDates(dates);

    const { queryFn: listTimeInLieusQueryFn, queryKey } = gqlQuery({
      req: "listTimeInLieus",
      vars: {
        filter:
          id.length > 0
            ? {
                employeeID: { contains: id },
                dateTaken: { between: dateRange },
              }
            : {
                dateTaken: { between: dateRange },
              },
        ...input.vars,
        ...(id.length > 0 && { id }),
      },
      key: id
        ? [dateRange, { id }, ...(input.key ?? [])]
        : [dateRange, ...(input.key ?? [])],
    });

    return {
      queryKey,
      queryFn: async () => {
        const { data: absenceData, errors: absenceErrors = [] } =
          await listTimeInLieusQueryFn();

        return {
          items: absenceData?.listTimeInLieus?.items as TimeInLieu[],
          errors: [...absenceErrors],
          nextToken: absenceData?.listTimeInLieus?.nextToken,
        };
      },
    };
  };
